import ERC20 from '@/infra/abis/ERC20.json';
import BN from 'bn.js';
import { sendEvent } from '@/web3-server/web3/handler/sendEvent';
export default function approveCurrency(request, currencyAddress, contractAddress) {
    const { web3, userWalletAddress } = request;
    const maxInt = new BN('2').pow(new BN('256')).sub(new BN('1'));
    const currencyContract = new web3.eth.Contract(ERC20.abi, currencyAddress);
    sendEvent(request, currencyContract.methods.approve(contractAddress, maxInt).send({ from: userWalletAddress }));
}
